module.exports = __webpack_public_path__ + "img/pr.a13f6943.jpg";